import { useQuery } from '@tanstack/react-query'
import { profile } from '@myap/ui-library'
import { isStudent } from '@myap/metadata'
import { getRequest } from '../utils/fetchOperations'
import { USER_DETAILS_KEY } from '../components/_common/reactquery'

const formatRoles = roles => {
  return roles.map(({ role, roleName }) => {
    return {
      role,
      roleName,
    }
  })
}

const useUserDetailsQuery = () => {
  const { apiUrl } = profile()
  return useQuery({
    queryKey: [USER_DETAILS_KEY],
    staleTime: 3600000,
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const userDetailsData = await getRequest({
        url: `${apiUrl}/mydetails`,
        params: { app: 'score' },
        signal,
      })
      const {
        firstName,
        lastName,
        namespace,
        personId,
        roles,
        termsAndConditions: { general: acceptedGeneralTAC },
      } = userDetailsData
      const hasRoles = roles?.length > 0
      const isStudentRole = hasRoles && isStudent(roles[0].role)
      const selectedOrgId = roles?.[0]?.orgId ?? null
      return {
        firstName,
        lastName,
        namespace,
        studentId: personId,
        acceptedGeneralTAC,
        roles: hasRoles ? formatRoles(roles) : [],
        isStudent: isStudentRole,
        selectedOrgId,
      }
    },
  })
}

export default useUserDetailsQuery
